import {generateTokensFromArray} from '../__utils';
import type {BoxShadowsTokens} from './box-shadows.types';

const boxShadows: Array<keyof BoxShadowsTokens> = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  'actionColored',
  'actionSecondary',
  'inputInner',
  'menu',
  'searchableList',
  'segmentedControl',
  'uiSelect',
  'uiNumberInputDefaultButtonActive',
  'uiNumberInputDefaultButtonInactive',
  'uiNumberInputStepper',
];

export const boxShadowTokens: BoxShadowsTokens = generateTokensFromArray(
  boxShadows,
  {
    prefix: 'box-shadows',
  }
);
